import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { Dropdown, Button, Input, Form, Icon, Tab, Menu, Label, Popup } from 'semantic-ui-react'
import { Text, Translate, LanguageContext } from '../../helpers/language';

class SearchFilters extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {activeTabIndex: this.props.activeTabIndex !== undefined ? this.props.activeTabIndex : 0};
    this.handleChange = this.handleChange.bind(this);    
  }

  componentDidMount () {        
  } 

  async componentDidUpdate(prevProps) {    
    if (prevProps.activeTabIndex !== this.props.activeTabIndex) {
        this.setState({activeTabIndex: this.props.activeTabIndex})
    }
  }

  handleChange(event, data) {
    this.setState({activeTabIndex : data.activeIndex});    
    if (this.props.handleTabChange)
        this.props.handleTabChange(event, data.activeIndex);
  }

  render(){
    const panes = [
      {
        menuItem: (<Menu.Item key='principles' disabled={this.props.disabled === true} >
                      {Translate(this.context, 'search_search_rules')}<Popup className='search_result_popup'
                                        trigger={<Icon circular size='small' name='info' className={'hvr-grow lisia-tab-info-icon'}/>}
                                        content={Translate(this.context,'search_search_rules_popup')}
                                        on='hover'
                                        hoverable={true}                         
                                  />
                   </Menu.Item>
                   )        
      },
      {
        menuItem: (<Menu.Item key='synthetic_principles' disabled={this.props.disabled === true}>
                      {Translate(this.context, 'search_search_verdicts')} <Popup className='search_result_popup'
                                        trigger={<Icon circular size='small' name='info' className={'hvr-grow lisia-tab-info-icon'}/>}
                                        content={Translate(this.context,'search_search_synthetic_popup')}
                                        on='hover'
                                        hoverable={true}                                
                                  />
                   </Menu.Item>
                  )
      }
    ]

    return (
      <div className='search-filters-wrapper'>        
        <Tab className='lisia-blue-tab' menu={{ secondary: true, pointing: true }} panes={panes} onTabChange={this.handleChange} activeIndex={this.state.activeTabIndex}/> 
      </div>
    )
  }

}

SearchFilters.contextType = LanguageContext;

SearchFilters.propTypes = {
  handleChange: PropTypes.func,
  handleTabChange: PropTypes.func 
}

export default SearchFilters
